import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { divisionSchemaObject } from '../devisionSchema';
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'DIVISION';

export function DivisionAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Division");
    const [buttonName, setButtonName] = useState("Save");
    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [isChanged, setIsChanged] = useState(0);
    const [collectionCategories, setCollectionCategories] = useState([]);
    const [division, setDivision] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionCategoryID: '0',
        collectionPointCode: '',
        collectionPointName: '',
        collectionPointLocation: '',
        isActive: true
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(divisionSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        
    }, []);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [division]);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown()
        )
    }, [division.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
    }, [division.operationEntityID]);

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITDIVISION');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });
        
        if (data && edit) {
            setTitle("Edit Division");
            setDivision(data);
            setButtonName("Update");
        } else {
            setTitle("Add Division");
            var token = tokenService.getUserDetailsFromToken();
            setDivision({
                ...division,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getGroupsForDropDown()
        );
    }


    async function getEsatesForDropDown() {
        const estateList = await services.getEstatesByGroupID(division.groupID);
        setEstates(estateList);
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(division.operationEntityID);
        setCollectionCategories(collectionCategories);
    }

    function handleChange(e) {
        const target = e.target

        if (target.name === "collectionPointCode") {
            if (target.value.length === 3) return false
        }

        const value = target.name === 'isActive' ? target.checked : target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, divisionSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setDivision({
            ...division,
            [e.target.name]: value
        })
        setErrors(error);
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, division);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return

        if (!edit) {
            const response = await services.saveDivision(division);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        } else if (edit) {
            const response = await services.editData(division);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/division' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setDivision({
            ...division,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCategoryID: '0',
            collectionPointCode: '',
            collectionPointName: '',
            collectionPointLocation: '',
            isActive: true
        });
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/division"
                            isChanged={isChanged}
                        />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">

                                <div className="form-group row">
                                    <div className="col-md pb-1">

                                        <TextField fullWidth select label="Group *"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={division.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Group--</option>
                                            {generateDropDownMenu(groups)}
                                        </TextField>
                                        {errors["groupID"] && <span id="errbranchCode" className="text text-danger">{errors["groupID"]}</span>}
                                    </div>
                                    <div className="col-md pb-1">

                                        <TextField fullWidth select label="Estate *"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={division.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Estate Name--</option>
                                            {generateDropDownMenu(estates)}
                                        </TextField>
                                        {errors["operationEntityID"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</span>}
                                    </div>
                                    <div className="col-md pb-1">    
                                        <TextField fullWidth select label="Collection Category *" 

                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            value={division.collectionCategoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Collection Category--</option>
                                            {generateDropDownMenu(collectionCategories)}
                                        </TextField>
                                        {errors["collectionCategoryID"] && <span id="errbranchCode" className="text text-danger">{errors["collectionCategoryID"]}</span>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Division Code *"
                                            name="collectionPointCode"
                                            id="collectionPointCode"
                                            value={division.collectionPointCode}
                                            type="number"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["collectionPointCode"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointCode"]}</span>}
                                    </div>
                                    <div className="col-md-4 pb-1">

                                        <TextField fullWidth label="Division Name *"
                                            name="collectionPointName"
                                            id="collectionPointName"
                                            value={division.collectionPointName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["collectionPointName"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointName"]}</span>}
                                    </div>
                                    <div className="col-md-4 pb-1">

                                        <TextField fullWidth label="Division Location"
                                            name="collectionPointLocation"
                                            id="collectionPointLocation"
                                            value={division.collectionPointLocation}
                                            type="text"
                                            rows="3"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["collectionPointLocation"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointLocation"]}</span>}
                                    </div>
                                </div>

                                <label>Active</label>
                                <div className="form-group row">
                                    <div className="col-md ">
                                        <input
                                            id="isActive"
                                            switch="none"
                                            className="mr-2"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={division.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <input
                                    disabled={validate(schema, division)}
                                    type="submit"
                                    className="btn btn-primary"
                                    value={buttonName}
                                />
                                <input
                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}